import React from 'react';
import { Outlet } from 'react-router-dom';
import { PublicRouteProps } from '../types/route';

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => (
    <>
        {children ? children : <Outlet />}
    </>
);

export default PublicRoute; 